var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEstateOwner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1653 0.831619L13.1375 16.8594L11.4203 15.1421L15.4272 11.1352L15.4272 7.70066L18.8617 7.70066L18.8617 4.26614L22.2962 4.26614L22.2962 0.831621L29.1653 0.831619Z",
    fill: "#A2A9AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4511 4.54888L15.1406 18.8594L13.1372 16.8559L29.4511 0.541941L29.4511 4.54888Z",
    fill: "#BEC8D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5677 15.4297C11.2483 12.1103 5.86636 12.1103 2.5469 15.4297C-0.772553 18.7492 -0.772553 24.1311 2.5469 27.4505C5.86636 30.77 11.2483 30.77 14.5677 27.4505C17.8872 24.1311 17.8872 18.7492 14.5677 15.4297ZM8.8433 21.1585C7.73681 20.0521 5.94284 20.0521 4.83636 21.1585C3.72987 22.265 3.72987 24.059 4.83636 25.1655C5.94284 26.272 7.73681 26.272 8.8433 25.1655C9.94978 24.059 9.94978 22.265 8.8433 21.1585Z",
    fill: "#A2A9AF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstateOwner);
export default __webpack_public_path__ + "static/media/IcEstateOwner.dacf4e8771496e64eeb4ed28a4c75762.svg";
export { ForwardRef as ReactComponent };